<template>
  <el-col
    :span="isMobileLayout ?  24 : isBlogPage ? 24 : 8"
    :class="[!isBlogPage ? 'p-8' : 'el-card is-never-shadow mb-40','blog-video']"
  >
    <el-row>
      <el-col :xs="24" :sm="24" :md="24">
        <div :class="['position-relative image_wrap',]">
          <a class="h-100 w-100" data-fancybox="video-gallery" :href="link">
            <div :class="['',  isBlogPage ? 'thumbnail__dimension' : 'video-thumbnai-img']">
              <img
                :src="youThumbnailImg"
                :class="[isBlogPage ? 'fix_img_height' : 'video-thumbnai-img']"
              />
            </div>
            <div class="position-absolute play-btn">
              <img :src="playBtn" />
            </div>
          </a>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :class="[isBlogPage?'blog__detail_h':'']">
        <h6 class="title text-uppercase mt-12 titleText" v-if="!isBlogPage">
          {{ title }}
        </h6>
        <div class="subtitle2 blog__title mt-5" v-else>
          {{ relatedProviders }}
        </div>
        <h5 :class="[isBlogPage?'subtitle1 blog__title mt-5' : 'title mt-12 titleDescription xs-mt-0']">
          {{ description }}
        </h5>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>

import { get } from "@/utils/lodash";
import "vue-plyr/dist/vue-plyr.css";
import layoutUtils from "@/utils/layout-utils";
import youThumbnail from "@/assets/images/home/you-thumbnail.jpg";
import playBtn from "@/assets/images/blog/video/blog-video-triangle-small.svg";

export default {
  data() {
    return {
      youThumbnailImg: this.thumbnailImage,
      playBtn,
    };
  },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    link: {
      type: String,
    },
    thumbnailImage: {
      type: String,
      default: youThumbnail
    },
    isBlogPage: {
      type: Boolean,
      default: false,
    },
    blog: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
    author() {
      const author = `By ${get(this.blog, "user.firstName")} ${get(
        this.blog,
        "user.lastName"
      )}`;

      return author != null ? author : "";
    },
    relatedProviders() {
      const author = `By ${get(this.blog.relatedProviders, "name")}`;

      return author != null && !author ? author : "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
$header-image-size-sm: 115px;
$header-image-size-lg: 146px;

.titleText {
  color: gray !important;
  font-family: "Futura-Normal", "Futura", sans-serif;
  font-weight: 300;
  font-size: 11px;
  letter-spacing: 1.5px;
  margin-bottom: 8px;
  margin-top: 10px;
}
.titleDescription {
  font-size: 15px;
  color: black !important;
}
.video-thumbnai-img {
  cursor: pointer;
  width: 100%;
  height: 350px;
  @media screen and (max-width: $media-sm) {
    width: 100% !important;
  }
}
.image_wrap {
  height: auto;
  a {
    height: 100% !important;
    width: 100% !important;
    display: flex;
    position: relative;
  }
}
.fix_img_height{
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
  background: rgb(0 0 0 / 50%);
  height: 66px;
  width: 66px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    transform: rotate(90deg);
    padding-bottom: 5px;
    width: 26px;
    height: 26px;
  }
}
.blog__title{
  background-color: rgba(255, 255, 255, 0);
  color: rgba(39, 36, 33, 0.7);
  box-sizing: border-box;
  text-align: left;
  line-height: normal;
}
.subtitle2{
  color: rgba(39, 36, 33, 0.7) !important;
}
.subtitle1{
  color: #272421 !important;
  letter-spacing: 0.25px !important;
}
.blog__detail_h {
height: 86px;
}
.el-card {
  border-radius: 0px;
  border: 0;
  background-color: #FFFFFF;
  color: #333333;
  // line-height: normal;
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    margin-bottom: 40px;
  }
  margin: 0;
}
</style>